import { useState } from 'react';
import * as S from './styles';
//components
import ActionButtonResponsy from '../../../components/Button/ActionButtonResponsy';
import { useMultipleModal } from '../../../hooks/useMultipleModal';
//icons
import { SlidersHorizontal, X } from '@phosphor-icons/react';

// Interface para uma opção individual do filtro
interface IFilterOption {
    id?: string | number;
    value: string | number;
}

// Interface para um filtro individual
interface IFilter {
    key: string;
    title: string;
    data: IFilterOption[] | string[]; // Suporta tanto objetos quanto strings simples
}

// Interface para o componente FilterTable
interface IProps {
    filters: IFilter[];
    onApplyFilters: (filters: Record<string, string | number>) => void;
    onClearFilters: () => void;
    initialValues?: Record<string, string | number>;
}

export default function FilterTable(
    {
        filters = [],
        onApplyFilters,
        onClearFilters,
        initialValues
    }: IProps) {
    const { isOpenModal, toggleModalVisibility } = useMultipleModal();
    const [filterValues, setFilterValues] = useState<Record<string, string | number>>(initialValues || {});

    // Função para ABRIR MODAL de filtros
    const handleButton = () => {
        toggleModalVisibility('filter-popup');
    }

    // Função para LIMPAR OS FILTROS e fechar o modal
    const handleClearFilters = () => {
        onClearFilters();
        toggleModalVisibility('filter-popup');
        setFilterValues({});
    }

    // Função para APLICAR OS FILTROS selecionados
    const handleApplyFilters = () => {
        onApplyFilters(filterValues); // <- Envia os filtros selecionados
        toggleModalVisibility('filter-popup');
    }

    // Função para lidar com a SELEÇÃO DE FILTROS
    const selectedFilters = (e: React.ChangeEvent<HTMLSelectElement>, type: string) => {
        const value = e.target.value;
        setFilterValues((prev) => ({
            ...prev,
            [type]: value
        }));
    }

    // Função para LIMPAR UM FILTRO ESPECÍFICO
    const handleClearUniqFilter = (key: string) => {
        setFilterValues((prev) => ({
            ...prev,
            [key]: ''
        }));
    }

    return (
        <S.Container>
            <ActionButtonResponsy
                Icon={<SlidersHorizontal size={24} />}
                name={'Filtros'}
                onClick={handleButton}
            />
            {
                isOpenModal('filter-popup') &&
                <S.Content>
                    <S.PopUp>

                        <S.Section>
                            <S.PopHeader>
                                <S.Text>Filtros</S.Text>
                                <S.Button
                                    className='button-close'
                                    onClick={() => toggleModalVisibility('filter-popup')}
                                    type='button'>
                                    <X size={20} />
                                </S.Button>
                            </S.PopHeader>
                        </S.Section>

                        <S.Body>

                            {filters.map((filter, index) => (
                                <S.Section key={filter.key || index}>
                                    <S.PopHeader>
                                        <S.Text className='label'>{filter.title}</S.Text>
                                        <S.Button
                                            onClick={() => handleClearUniqFilter(filter.key)}
                                            type='button'
                                        >
                                            Limpar
                                        </S.Button>
                                    </S.PopHeader>

                                    <S.Select
                                        value={filterValues[filter.key] || ''}
                                        onChange={(e) => {
                                            selectedFilters(e, filter.key);
                                        }}
                                    >
                                        <option value="" disabled selected hidden>Selecione</option>
                                        {filter.data.map((option, optionIndex) => {
                                            // Suporte para objetos ou strings
                                            const value = typeof option === 'string' ? option : option.value;
                                            const key = typeof option === 'string' ? optionIndex : option.id || optionIndex;

                                            return (
                                                <option
                                                    key={key}
                                                    value={value}
                                                >
                                                    {value}
                                                </option>
                                            );
                                        })}
                                    </S.Select>
                                </S.Section>
                            ))}
                        </S.Body>

                        <S.Footer>
                            <S.Button
                                className='button-cancel'
                                type='button'
                                onClick={handleClearFilters}
                            >
                                Limpar
                            </S.Button>
                            <S.Button
                                className='button-submit'
                                onClick={handleApplyFilters}
                                type='button'
                            >
                                Aplicar
                            </S.Button>
                        </S.Footer>
                    </S.PopUp>
                </S.Content>
            }
        </S.Container >
    )
}